import { clampCookieIconShadow } from './cookieIcon3dButton';

/** @param {string} suffix */
export function cookieIcon3dFillUrl(suffix) {
  return `url(#acb-icon-${suffix}-fill)`;
}

/** @param {string} suffix */
export function cookieIcon3dFilterUrl(suffix) {
  return `url(#acb-icon-${suffix}-depth)`;
}

/** @param {string} suffix */
function resolveCookieIcon3dConfig(suffix) {
  if (suffix === "cookie") {
    return {
      gradient: { x1: 256, y1: 43, x2: 256, y2: 469 },
      shadow: { dy1: 25.6, dy2: -8.5, std1: 11.73, std2: 4.27 },
    };
  }

  if (suffix === "shield") {
    return {
      gradient: { x1: 8, y1: 1.33, x2: 8, y2: 14.67 },
      shadow: { dy1: 0.8, dy2: -0.27, std1: 0.37, std2: 0.13 },
    };
  }

  return {
    gradient: { x1: 12, y1: 2, x2: 12, y2: 22 },
    shadow: { dy1: 1.2, dy2: -0.4, std1: 0.55, std2: 0.2 },
  };
}

/**
 * @param {string} suffix
 * @param {number} [amount=100] same scale as cookie_icon_shadow (0–100)
 */
export function cookieIcon3dDefsHtml(suffix, amount = 100) {
  const t = clampCookieIconShadow(amount) / 100;
  const fillId = `acb-icon-${suffix}-fill`;
  const depthId = `acb-icon-${suffix}-depth`;
  const { gradient, shadow } = resolveCookieIcon3dConfig(suffix);
  const midOpacity = 1 - (1 - 0.94) * t;
  const endOpacity = 1 - (1 - 0.76) * t;
  const std1 = Math.max(0.001, shadow.std1 * t);
  const std2 = Math.max(0.001, shadow.std2 * t);

  return (
    "<defs>" +
    `<linearGradient id="${fillId}" x1="${gradient.x1}" y1="${gradient.y1}" x2="${gradient.x2}" y2="${gradient.y2}" gradientUnits="userSpaceOnUse">` +
    '<stop offset="0%" stop-color="currentColor" stop-opacity="1"/>' +
    `<stop offset="45%" stop-color="currentColor" stop-opacity="${midOpacity}"/>` +
    `<stop offset="100%" stop-color="currentColor" stop-opacity="${endOpacity}"/>` +
    "</linearGradient>" +
    `<filter id="${depthId}" x="-30%" y="-30%" width="160%" height="160%">` +
    `<feDropShadow dx="0" dy="${shadow.dy1 * t}" stdDeviation="${std1}" flood-color="#000" flood-opacity="${0.26 * t}"/>` +
    `<feDropShadow dx="0" dy="${shadow.dy2 * t}" stdDeviation="${std2}" flood-color="#fff" flood-opacity="${0.14 * t}"/>` +
    "</filter></defs>"
  );
}
